import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title-section" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "table-cell dish-cell" }
const _hoisted_6 = { class: "dish-info" }
const _hoisted_7 = { class: "dish-name" }
const _hoisted_8 = { class: "tags" }
const _hoisted_9 = { class: "table-cell" }
const _hoisted_10 = { class: "table-cell" }
const _hoisted_11 = { class: "table-cell" }
const _hoisted_12 = { class: "table-cell" }
const _hoisted_13 = { class: "modal-content" }
const _hoisted_14 = { class: "dish-container" }
const _hoisted_15 = { class: "dish-title" }
const _hoisted_16 = { class: "dish-name" }
const _hoisted_17 = { class: "dish-location" }
const _hoisted_18 = { class: "quantity-control" }
const _hoisted_19 = { class: "stepper-container" }
const _hoisted_20 = { class: "quantity-total" }
const _hoisted_21 = { class: "stoves-list" }
const _hoisted_22 = { class: "stove-content" }
const _hoisted_23 = { class: "stove-name" }
const _hoisted_24 = { class: "stove-status" }

import { ref, computed } from 'vue';
  import { DishItemNewModel, StoveItemModel } from '../model/kitchen';

  // 模态框状态
  
export default /*@__PURE__*/_defineComponent({
  __name: 'KitchenCommodityNewCompent',
  props: {
    tableData: { default: () => [] },
    stovesData: { default: () => [] }
  },
  setup(__props: any) {

  const showAssignModal = ref(false);
  const currentDish = ref<DishItemNewModel | null>(null);
  const assignQuantity = ref(1);

  // 接收父组件传递的数据（使用模拟数据作为默认值）
  const props = __props;

  // 分配按钮点击事件
  const handleAssignClick = (dish: DishItemNewModel) => {
    console.log('分配按钮点击事件', dish);
    currentDish.value = dish;
    assignQuantity.value = 1;
    showAssignModal.value = true;
    console.log('分配弹窗状态:', showAssignModal.value);
  };

  // 弹窗打开事件
  const handleDialogOpen = () => {
    console.log('弹窗已打开');
  };

  // 计算总菜品和总份数
  const summaryText = computed(() => {
    const dishCount = props.tableData?.length || 0;
    const portionCount = props.tableData?.reduce((sum, item) => sum + item.portions, 0) || 0;
    return `${dishCount}道菜品，${portionCount}份`;
  });

  // 根据菜品类型获取对应的CSS类
  const getTypeClass = (type: string) => {
    switch (type) {
      case '热菜':
        return 'hot-tag';
      case '冷菜':
        return 'cold-tag';
      case '点心':
        return 'dim-sum-tag';
      case '饮品':
        return 'drink-tag';
      default:
        return '';
    }
  };

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_stepper = _resolveComponent("van-stepper")!
  const _component_van_grid_item = _resolveComponent("van-grid-item")!
  const _component_van_grid = _resolveComponent("van-grid")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_icon, {
            name: "fire-o",
            size: "24",
            color: "white"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "title-text" }, "待分配菜品", -1))
        ]),
        _createVNode(_component_van_tag, { class: "info-tag" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(summaryText.value), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"table-header\" data-v-7fd6bf74><div class=\"header-cell dish-header\" data-v-7fd6bf74>菜品名称</div><div class=\"header-cell\" data-v-7fd6bf74>桌位</div><div class=\"header-cell\" data-v-7fd6bf74>份数</div><div class=\"header-cell\" data-v-7fd6bf74>时间</div><div class=\"header-cell\" data-v-7fd6bf74>操作</div></div>", 1)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["table-row", { 'urgent-row': item.isUrgent }])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_8, [
                  (item.type)
                    ? (_openBlock(), _createBlock(_component_van_tag, {
                        key: 0,
                        class: _normalizeClass([getTypeClass(item.type), "type-tag"])
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.type), 1)
                        ]),
                        _: 2
                      }, 1032, ["class"]))
                    : _createCommentVNode("", true),
                  (item.isUrgent)
                    ? (_openBlock(), _createBlock(_component_van_tag, {
                        key: 1,
                        class: "urgent-tag"
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("加急", -1)
                        ])),
                        _: 1,
                        __: [3]
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.location), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.portions) + "份", 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.time), 1),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_van_button, {
                class: "assign-btn",
                size: "small",
                onClick: ($event: any) => (handleAssignClick(item))
              }, {
                default: _withCtx(() => _cache[4] || (_cache[4] = [
                  _createTextVNode("分配", -1)
                ])),
                _: 2,
                __: [4]
              }, 1032, ["onClick"])
            ])
          ], 2))
        }), 128))
      ])
    ]),
    _createVNode(_component_van_dialog, {
      show: showAssignModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showAssignModal).value = $event)),
      class: "assign-modal",
      title: "选择分配灶台",
      "title-align": 'left',
      closeable: true,
      "show-cancel-button": false,
      "show-confirm-button": false,
      teleport: "body",
      style: { zIndex: 9999, width: '50%', textAlign: 'left !important' },
      mask: true,
      "message-align": "left",
      onOpen: handleDialogOpen
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("span", _hoisted_16, _toDisplayString(currentDish.value?.name), 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(currentDish.value?.location), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "quantity-label" }, "分配数量：", -1)),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_van_stepper, {
                  modelValue: assignQuantity.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((assignQuantity).value = $event)),
                  class: "stepper",
                  min: 1,
                  max: currentDish.value?.portions || 1,
                  "button-size": "32"
                }, null, 8, ["modelValue", "max"])
              ]),
              _createElementVNode("span", _hoisted_20, "/共" + _toDisplayString(currentDish.value?.portions || 0) + "份", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_van_grid, {
              border: false,
              "column-num": 2,
              direction: "horizontal",
              style: {"padding-left":"0"}
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stovesData, (stove) => {
                  return (_openBlock(), _createBlock(_component_van_grid_item, {
                    key: stove.id,
                    class: "stove-item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(stove.name), 1),
                        _createElementVNode("div", _hoisted_24, "队列" + _toDisplayString(stove.assignedTasks) + "/" + _toDisplayString(stove.availableTasks), 1)
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})